import Crud from '../components/Branch/Crud'
import Entity from '../components/Branch/Add'
import View from '../components/Branch/View'
import Edit from '../components/Branch/Edit'

let routes = {
    path: '/branches',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/branches/add',
            name: 'Nova Filial',
            component: Entity
        },
        {
            path: '/branches/edit/:id?',
            name: 'Editar Filial',
            component: Edit
        },
        {
            path: '/branches/view/:id?',
            name: 'Visualizar Filiais',
            component: View
        },
        {
            path: '/branches',
            name: 'Filiais',
            component: Crud
        }

    ]
};



export default routes



// WEBPACK FOOTER //
// ./src/router/branch.js